// XRay kabuk bileşenleri (components/xray) dosya adlarıyla global kaydedilir.
const components = require.context('../components/xray')

export default {
  install(app) {
    // require.context her dosyayı uzantılı ve uzantısız iki anahtarla listeler; Vue 3 ikinci kaydı uyarır.
    const registered = new Set()
    components.keys().forEach((fileName) => {
      const componentName = fileName.split('/').pop().split('.')[0]
      if (registered.has(componentName)) return
      registered.add(componentName)
      const componentConfig = components(fileName)
      app.component(componentName, componentConfig.default || componentConfig)
    })
  }
}
